import { render, staticRenderFns } from "./TeacherTimeline.vue?vue&type=template&id=0043b3b4&"
import script from "./TeacherTimeline.vue?vue&type=script&lang=js&"
export * from "./TeacherTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports